"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _appendCss = _interopRequireDefault(require("../../utils/appendCss"));
var _Checkbox_css = _interopRequireDefault(require("./Checkbox_css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Checkbox Component
 *
 * @FormGroupCompatible
 * @export
 * @class Checkbox
 * @extends {Component}
 */
class Checkbox extends _react.Component {
  constructor(props) {
    super(props);
    /**
     * Click Event Handler
     * If disabled, this handler is ignored
     * If onChange prop exists, then that function is also called
     *
     * @param {object} event
     */
    (0, _defineProperty2.default)(this, "handleClick", event => {
      if (this.props.isDisabled) return;
      if ("onFormValueChanged" in this.props) {
        this.props.onFormValueChanged(!this.props.isChecked);
      }
      if ("onChange" in this.props) {
        this.props.onChange({
          label: this.props.label,
          value: this.props.value,
          isChecked: !this.props.isChecked
        }, event);
      }
    });
    (0, _appendCss.default)("arc_cbx", _Checkbox_css.default);
    this.inputId = this.props.id ? this.props.id : (0, _lodash.uniqueId)("chbxel_");
  }
  render() {
    const {
      label,
      isChecked,
      value,
      name,
      isRequired,
      isDisabled,
      themeColor,
      additionalProps
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "checkbox__elem"
    }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      type: "checkbox",
      id: this.inputId,
      name: name,
      value: value,
      checked: isChecked,
      required: isRequired,
      onChange: this.handleClick
    }, isDisabled ? {
      disabled: true
    } : {}, additionalProps)), /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)({
        "t-body-large": true,
        "disabled": isDisabled,
        ["".concat(themeColor, "-color")]: true
      }),
      htmlFor: this.inputId
    }, label));
  }
}
exports.default = Checkbox;
Checkbox.propTypes = {
  /** Checkbox label */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Defines whether checkbox is checked */
  isChecked: _propTypes.default.bool,
  /** Defines whether checkbox is disabled */
  isDisabled: _propTypes.default.bool,
  /** Specifies whether checkbox is required in form */
  isRequired: _propTypes.default.bool,
  /** value HTML attribute */
  value: _propTypes.default.string,
  /** Checkbox Form name */
  name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Checkbox ID HTML attribute */
  id: _propTypes.default.string,
  /** Change event handler */
  onChange: _propTypes.default.func,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"]),
  /** allows for additional key:value pairs to apply to the input HTML element */
  additionalProps: _propTypes.default.object
};
Checkbox.defaultProps = {
  isChecked: false,
  isRequired: false,
  isDisabled: false,
  label: "",
  value: "",
  name: "",
  themeColor: "primary"
};